import React, { useEffect, useState } from "react";
import { swalError } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { useAuthActions, useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import { useRouter } from "next/router";
import { MdFavorite, MdFavoriteBorder } from "react-icons/md";
import { useRecoilValue } from "recoil";
import styles from "./actions.module.scss";
import { ImSpinner8 } from "react-icons/im";

export const FavoriteAction = ({
  referance,
  referanceId,
  is_favorite,
  fetchFavCourseData = false,
  fetchFavUniData = false,
  ...props
}) => {
  const router = useRouter();
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();
  const authActions = useAuthActions();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, []);

  //Handle University Favourite
  const handleUniFavourite = async (universityId) => {
    setIsLoading(true);
    if (profileInfo && profileInfo.userTypeSlug === "student") {
      await API.post(`/student/favourite-university`, { universityId }).then(
        async (resp) => {
          if (!resp.error && resp.data) {
            if (fetchFavUniData) fetchFavUniData();
            await authActions.getProfile();
            setIsLoading(false);
          } else {
            swalError(resp.error);
            setIsLoading(false);
          }
        }
      );
    } else if (profileInfo && profileInfo.userTypeSlug !== "student") {
      setIsLoading(false);
      return;
    } else {
      setIsLoading(false);
      systemActions.setReturnUrl(router.asPath);
      await router.push({ pathname: "/signin" });
    }
  };

  //course favorite
  const handleCourseFavourite = async (courseId) => {
    setIsLoading(true);
    if (profileInfo && profileInfo.userTypeSlug === "student") {
      await API.post(`/student/favorite-course`, { courseId }).then(
        async (resp) => {
          if (!resp.error && resp.data) {
            if (fetchFavCourseData) fetchFavCourseData();
            await authActions.getProfile();
            setIsLoading(false);
          } else {
            swalError(resp.error);
            setIsLoading(false);
          }
        }
      );
    } else if (profileInfo && profileInfo.userTypeSlug !== "student") {
      setIsLoading(false);
      return;
    } else {
      setIsLoading(false);
      systemActions.setReturnUrl(router.asPath);
      await router.push({ pathname: "/signin" });
    }
  };

  const renderComponent = () => {
    //for active
    if (is_favorite == false) {
      if (referance && referance == "university" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdFavoriteBorder
                className={`${styles.icon_heart}`}
                onClick={() => handleUniFavourite(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}

            {!profileInfo ? (
              <div className={`uni-tooltip`}>
                Please Login <br /> to perform this action
              </div>
            ) : (
              <div className={`uni-tooltip`}>
                Add to <br /> favourite
              </div>
            )}
          </div>
        );
      }

      if (referance && referance == "course" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdFavoriteBorder
                className={`${styles.icon_heart}`}
                onClick={() => handleCourseFavourite(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            {!profileInfo ? (
              <div className={`uni-tooltip`}>
                Please Login <br /> to perform this action
              </div>
            ) : (
              <div className={`uni-tooltip`}>
                Add to <br /> favourite
              </div>
            )}
          </div>
        );
      }
    }
    //for inactive
    if (is_favorite == true) {
      if (referance && referance == "university" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdFavorite
                className={`${styles.icon_heart} ${styles.selected}`}
                onClick={() => handleUniFavourite(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            <div className={`uni-tooltip`}>
              Remove from <br /> favourite
            </div>
          </div>
        );
      }

      if (referance && referance == "course" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdFavorite
                className={`${styles.icon_heart} ${styles.selected}`}
                onClick={() => handleCourseFavourite(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            <div className={`uni-tooltip`}>
              Remove from <br /> favourite
            </div>
          </div>
        );
      }
    }
  };

  if (typeof window !== "undefined") {
    return renderComponent();
  }

  return false;
};

export default FavoriteAction;
